import { FC } from 'react';

import FmdGoodIcon from '@mui/icons-material/FmdGood';
import Button from '@mui/material/Button';
import ToolCard from 'components/ToolCard';

const PoiCard: FC = () => (
  <ToolCard
    icon={<FmdGoodIcon fontSize="large" />}
    title="Lankytinos vietos"
    description="Lankytinų vietų straipsnių administravimas"
    action={
      <Button href="pois" startIcon={<FmdGoodIcon />} size="small">
        Administruoti
      </Button>
    }
  />
);

export default PoiCard;
